import { calcMargine } from "@/lib/margine";

// Margine iniziale (preventivo originale, costi previsti) e attuale (tutti i preventivi, costi reali o previsti).
// Le provvigioni sono già nel calcolo del margine unico (provPct), quindi non vanno sommate due volte.
export function marginiCommessa(marg, params) {
  const m = marg || {};
  const altri = (Number(m.altri_costi) || 0) - (Number(m.provvigioni) || 0);
  const iniziale = calcMargine(m.ricavo_iniziale, m.costo_previsto_iniziale, params);
  const attuale = calcMargine(m.ricavo_attuale, (Number(m.costo_reale_voci) || 0) + (Number(m.extra_artigiani) || 0) + altri, params);
  return { iniziale, attuale };
}

export const TIPI_SOGGETTO = [
  { value: "artigiano", label: "Artigiano / subappalto" },
  { value: "fornitore", label: "Fornitore materiali" },
  { value: "professionista", label: "Professionista / tecnico" },
  { value: "interno", label: "Operai interni" },
];
export const soggettoLabel = (t) => (TIPI_SOGGETTO.find((x) => x.value === t) || TIPI_SOGGETTO[0]).label;

export const costoReale = (it) => {
  const e = it.affidamento?.costo_effettivo;
  return e == null ? null : Number(e);
};

export const scartoPct = (it) => {
  const r = costoReale(it);
  const p = Number(it.costo_previsto) || 0;
  return r == null || !p ? null : ((r - p) / p) * 100;
};
